// services
import AxiosInstanceCreator from 'services/api';
import { COOKIE_ACCESS_TOKEN, cookieStorage } from 'services/cookie';

// libraries
import axios from 'axios';

const odmInstance = new AxiosInstanceCreator().create();

const API_BASE = import.meta.env.DEV ? '/v1/api' : `${import.meta.env.VITE_API_URL}/v1/api`;

export interface OdmProcessingResponse {
  processingId: string;
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
}

export interface OdmProcessing {
  id: number;
  processingId: string;
  site: string;
  date: string;
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
  imageCount?: number;
  imageUrl?: string;
  selected: boolean;
  del: boolean;
}

export const odmApi = {
  async uploadPhotos(site: string, images: File[]): Promise<OdmProcessingResponse> {
    const formData = new FormData();
    formData.append('site', site);
    images.forEach((file) => formData.append('images', file));

    const token = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);
    const response = await axios.post(`${API_BASE}/odm/upload`, formData, {
      withCredentials: true,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'X-PKG-ID': 'saf4s'
      }
    });
    return response.data;
  },

  async getProcessingStatus(processingId: string): Promise<OdmProcessingResponse> {
    const response = await odmInstance.get(`/odm/status/${processingId}`);
    return response.data;
  },

  async getProcessingList(): Promise<OdmProcessing[]> {
    const response = await odmInstance.get('/odm/list');
    return response.data;
  },

  async getProcessing(id: number): Promise<OdmProcessing> {
    const response = await odmInstance.get(`/odm/${id}`);
    return response.data;
  },

  async selectModel(id: number): Promise<void> {
    await odmInstance.put(`/odm/${id}/select`);
  },

  async deleteProcessing(id: number): Promise<void> {
    await odmInstance.delete(`/odm/${id}`);
  }
};
